import React from "react";

import AddIcon from "@mui/icons-material/Add";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Stack } from "@mui/material";

import { NotesTableColumns } from "../helpers";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import EmptyTable from "@src/sharedComponents/Table/EmptyTable";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./states.module.css";

export const EmptyNotesState = ({
  onNewNoteClick,
}: {
  onNewNoteClick: () => void;
}) => (
  <EmptyTable
    emptyRows={10}
    columns={NotesTableColumns}
    noBorderRadius={false}
    emptyCell={<Stack height={"20px"} />}
  >
    <Stack gap={1}>
      <Text variant="body" color="textSubtle" style={{ textAlign: "center" }}>
        No notes yet
      </Text>
      <Button
        buttonType="primary"
        variant="contained"
        text="New Note"
        startIcon={<AddIcon />}
        onClick={onNewNoteClick}
        size="small"
      />
    </Stack>
  </EmptyTable>
);

export const ErrorNotesState = ({
  onRetryClick,
}: {
  onRetryClick?: () => void;
}) => (
  <EmptyTable
    emptyRows={10}
    columns={NotesTableColumns}
    noBorderRadius={false}
    emptyCell={<Stack height={"20px"} />}
  >
    <Stack gap={1}>
      <Stack direction={"row"} alignItems="center" gap={1}>
        <ErrorIcon
          color={"disabled"}
          className={styles.icon}
          width={"14px"}
          height={"14px"}
        />
        <Text variant="body">Error loading notes</Text>
      </Stack>

      <Button
        buttonType="secondary"
        variant="contained"
        text="Retry"
        endIcon={<RefreshIcon />}
        onClick={onRetryClick ?? (() => undefined)}
        size="small"
      />
    </Stack>
  </EmptyTable>
);
